import { paths } from '@luxuryescapes/contract-business'
import requestUtils, { authOptions } from 'api/requestUtils'
import { EMPLOYEE_CREDIT_CUSTOMER_UPDATE_ERRORS } from './creditCustomerErrors'

type MyCreditCustomerIdUpdateRequestPayload =
  paths['/api/business-traveller/me/credit-customer-id']['patch']['requestBody']['content']['application/json']

/**
 * Self-service link of the authenticated employee's personal Luxury Escapes account.
 * Auth is the LEBT session (cookie); the linked account identity is derived server-side from the
 * verified LE access token, so no creditCustomerId is sent in the body.
 */
async function requestPatchMyCreditCustomerId(payload: MyCreditCustomerIdUpdateRequestPayload) {
  try {
    await requestUtils.patch<unknown, MyCreditCustomerIdUpdateRequestPayload>(
      // without_brand=1: keep brandLoader from adding `brand` to the strict-schema body
      '/api/business-traveller/me/credit-customer-id?without_brand=1',
      payload,
      authOptions(),
    )

    return true
  } catch(error: any) {
    switch (error?.message) {
      case 'Employee not found in the business':
        return Promise.reject(EMPLOYEE_CREDIT_CUSTOMER_UPDATE_ERRORS.NOT_FOUND)
      case 'Credit customer ID already set':
        return Promise.reject(EMPLOYEE_CREDIT_CUSTOMER_UPDATE_ERRORS.ALREADY_SET)
      default:
        return Promise.reject(EMPLOYEE_CREDIT_CUSTOMER_UPDATE_ERRORS.OTHER)
    }
  }
}

export default requestPatchMyCreditCustomerId
